import { marketImages } from "@/mocks/techData";

const moments = [
  { key: "phones", label: "Phones", caption: "Mobiles ready to compare and pick." },
  { key: "laptop", label: "Laptops", caption: "Everyday computing on the move." },
  { key: "accessories", label: "Accessories", caption: "Chargers, cases and sound." },
];

export default function MarketStall() {
  return (
    <section id="market" className="bg-foreground-950 py-20 md:py-28">
      <div className="container-x">
        <div className="mb-10 max-w-2xl md:mb-14">
          <p className="eyebrow-light mb-4 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-primary-500"></span>
            The Market
          </p>
          <h2 className="section-title-light">Find us out there.</h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/70">
            Fist Limited also brings mobiles, laptops and everyday technology accessories directly to
            customers through market stalls — same range, same friendly service.
          </p>
        </div>

        {/* Wide market hero */}
        <div className="relative overflow-hidden rounded-xl">
          <div className="aspect-[4/3] md:aspect-[21/9]">
            <img
              src={marketImages.wide}
              alt="Fist Limited market stall displaying mobile phones, laptops and accessories"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 p-6 md:p-8">
            <p className="font-heading text-2xl text-background-50 md:text-3xl">Mobile. Laptop. Everyday.</p>
            <p className="mt-2 max-w-md text-sm text-background-100/75">
              A curated tech range on display — stop by and see what's new.
            </p>
          </div>
        </div>

        {/* Horizontal story */}
        <div className="mt-5 grid gap-4 md:grid-cols-3 md:gap-5">
          {moments.map((m) => (
            <figure key={m.key} className="group relative overflow-hidden rounded-lg">
              <div className="aspect-[4/3]">
                <img
                  src={marketImages[m.key as keyof typeof marketImages]}
                  alt={`${m.label} at the Fist Limited market stall in Liverpool`}
                  className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                />
              </div>
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/90 to-transparent p-5">
                <p className="font-heading text-lg text-background-50">{m.label}</p>
                <p className="mt-1 text-xs text-background-100/70">{m.caption}</p>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 flex flex-col items-start justify-between gap-6 rounded-lg border border-foreground-800 bg-foreground-900 p-6 md:flex-row md:items-center md:p-8">
          <div>
            <h3 className="font-heading text-2xl text-background-50 md:text-3xl">Come say hello.</h3>
            <p className="mt-2 max-w-md text-sm text-background-100/70">
              Follow our market dates, or visit the shop on Eastdale Road — we'd love to help.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a href="#visit" className="btn-primary h-12 px-6 text-sm">
              Visit Us <i className="ri-arrow-right-line"></i>
            </a>
            <a href="tel:07909324302" className="btn-light-outline h-12 px-6 text-sm">
              <i className="ri-phone-line"></i> 07909 324302
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}